<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <b-form @submit.prevent="updateLead">
          <h1 class="title mb-3">Update Details</h1>
          <div class="card">
            <div class="card-body p-2">
              <div class="form-group">
                <label for="">Status</label>
                <select class="custom-select"  v-model="$v.lead.status_id.$model">
                  <option selected="selected" disabled>Select Status</option>
                  <option v-for="status in statusList" :value="status.id">{{status.name}}</option>
                </select>
                <div class="error" v-if="$v.lead.status_id.$error"> Field is required</div>
              </div>
              <div class="form-group p-2 mb-1" v-if="canShowEmpanelmentDate">
                <label for="empanelmentdate">Empanelment Date<span class="text-danger">*</span></label>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Empanelment Date"
                  required
                  ref="empanelmentdate"
                  v-model="lead.empanelment_done_date"
                />
              </div>
              <div class="form-group p-2 mb-1" >
                <label for="nextcalldate">Next Call Date</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  placeholder="Next Call Date"
                  v-model="lead.ncd"
                />
              </div>
              <div class="form-group p-2 mb-1">
                <label for="firmAddress">Comments</label>
                <textarea
                  type="text"
                  class="form-control"
                  placeholder="Enter Comments"
                  ref="firmAddress"
                  rows="3"
                  v-model="lead.comment"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="form-group m-0">
              <button type="submit" :disabled="$v.$invalid" class="btn btn-primary btn-block">
                Update
              </button>
            </div>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>
<script>
import SingleTagInput from "@/components/Forms/SingleTagInput.vue";
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages'
import { EMPANELMENT_STATUS_IDS } from "@/assets/scripts/utility.js";
const formMessages = {
  required: () => 'Field is required',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be at most ${$params.txtMaxLen.max} characters.`,
  email: () => 'Should be valid email',
}

export default {
  components: {
    SingleTagInput,
  },
  name: "Brokeredit",
  data: () => {
    return {
      dialog: false,
      lead: {
      },
      selectedStatus: {},
      hasStatusError: false
    };
  },
  validations: {
    lead: {
      status_id: {
        required
      }
    },
  },
  created() {
    this.fetchBrokerDetail();
  },
  methods: {
    updateLead() {
      let uuid = this.$route.params.id;
      this.$axios
        .put(`leads/${uuid}`, { lead: {next_call_date_and_time: this.lead.ncd, comment: this.lead.comment, status_id: this.lead.status_id, empanelment_done_date: this.lead.empanelment_done_date }})
        .then((res) => {
          swal({
            title: "Broker Lead Updated!",
            icon: "success",
          }).then(this.$router.replace({ name: "Broker", id: uuid}));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
    fetchBrokerDetail(){
      let uuid = this.$route.params.id;
      this.$axios.get(`leads/${uuid}`).then((res) => {
        this.lead = res.data.lead;
      });
    }
  },
  computed: {
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    validationMsg(){
      return validationMessage(formMessages);
    },
    canShowEmpanelmentDate(){
      return (EMPANELMENT_STATUS_IDS.includes(this.lead.status_id))
    }
  },
};
</script>
<style  scoped>
label {
  letter-spacing: 0.01em;
  font-size: 14px;
  font-weight: 500;
}
.form-control {
  font-size: 14px;
}
</style>